export default __webpack_public_path__ + "static/media/defient-stack3.webp";